import styled, { css } from 'styled-components';

interface DonutProps {
  color: string;
  donutBorderWidth?: number | string;
  donutSize?: string;
  outsidelabel?: string;
  active?: boolean;
}

interface DonutContainerProps {
  minWidth?: number;
  separateDonuts?: boolean;
  canSelect?: boolean;
}

export const DonutContainer = styled.div<DonutContainerProps>`
  height: 100%;
  width: 100%;
  min-width: ${({ minWidth }) => `${minWidth}px`};
  display: flex;
  justify-content: space-around;

  ${({ separateDonuts }) =>
    separateDonuts &&
    css`
      justify-content: center;
      background-color: #fafafa;
      border: 0.5px solid #e4e4e4;
      box-sizing: border-box;
      padding: 5px;
      gap: 5px;

      p {
        width: 100%;
        height: 20px;
        text-align: left;
      }
    `}
`;

export const DonutContentContainer = styled.button<DonutContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;

  cursor: ${({ canSelect }) => (canSelect ? 'pointer' : 'default')};

  ${({ separateDonuts }) =>
    separateDonuts &&
    css`
      width: 20%;
      padding: 5px;
      flex-direction: column;
      background-color: #fff;
      border: 0.5px solid #e4e4e4;
      box-sizing: border-box;
    `}
`;

export const DonutItem = styled.div<DonutProps>`
  height: ${({ donutSize }) => donutSize || '70px'};
  width: ${({ donutSize }) => donutSize || '70px'};
  border: ${({ donutBorderWidth }) => donutBorderWidth || '5px'} solid
    ${({ color, active, theme }) => (active ? color : theme.colors.borderGrey)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0 2px;

  .value {
    font-weight: 600;
  }
  .label {
    font-size: 8px;
    text-align: center;
    padding: 0px 2px;
    line-height: normal;
  }
`;
